import axios from "axios";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const apiUrl = "index.php";
const ARCHIVED = 1;
const NOT_ARCHIVED = 0;

const setReasonArchiveStatus = (state, reasonId, status) => {
    const reason = state.reasons.find((s) => s.id === reasonId);
    reason.is_archive = status;
};

const state = () => ({
    reasons: [],
    isMoreDataAvailable: true,
    totalCount: 0,
});

const mutations = {
    setReasons(state, reasons) {
        state.reasons = reasons;
    },
    putNewReason(state, reason) {
        state.reasons.unshift(reason);
    },
    putNewReasons(state, reasons) {
        state.reasons = [...state.reasons, ...reasons];
    },
    updateReason(state, reasonData) {
        const reason = state.reasons.find((s) => s.id === reasonData.id);
        Object.keys(reason).forEach((key) => {
            reason[key] = reasonData[key];
        });
    },
    deleteReason(state, reasonId) {
        state.reasons = state.reasons.filter((s) => s.id !== reasonId);
    },
    moveReasonToArchive(state, reasonId) {
        setReasonArchiveStatus(state, reasonId, ARCHIVED);
    },
    moveReasonFromArchive(state, reasonId) {
        setReasonArchiveStatus(state, reasonId, NOT_ARCHIVED);
    },
    setIsMoreDataAvailableValue(state, value) {
        state.isMoreDataAvailable = value;
    },
    setTotalCount(state, value) {
        state.totalCount = value;
    },
};

const actions = {
    async fetchReasons({ rootState, commit }, { page, searchQuery, type }) {
        const token = rootState.authToken;
        const route = "api/candidate-refusal/index";
        const queryParams = [];

        if (page) {
            queryParams.push(`page=${page}`);
        }
        if (searchQuery) {
            queryParams.push(`search=${searchQuery}`);
        }
        if (type && type !== "all") {
            queryParams.push(`search_type=${type === "archived" ? "archive" : "active"}`);
        }

        const url = addAuthKey(`${apiUrl}/?r=${route}&sort=-sort&per-page=50&${queryParams.join("&")}`, token);

        const { data, headers } = await axios.get(url);

        commit("setTotalCount", headers["x-pagination-total-count"]);

        if (!data.length) {
            commit("setIsMoreDataAvailableValue", false);
        } else {
            commit("setIsMoreDataAvailableValue", true);
        }

        if (page === 1) {
            commit("setReasons", data);
        }
        if (page > 1) {
            commit("putNewReasons", data);
        }
    },
    async createReason({ rootState, commit }, reasonData) {
        const token = rootState.authToken;

        const requestData = {
            name: reasonData.name,
            type: reasonData.isCandidateRejected ? "20" : "10",
        };

        const url = addAuthKey(`${apiUrl}/?r=api/candidate-refusal/create`, token);

        const { data } = await axios.post(url, requestData);

        if (data.success) {
            commit("putNewReason", data.model);
        }

        return data;
    },
    async updateReason({ rootState, commit }, reasonData) {
        const token = rootState.authToken;
        const reasonId = reasonData.id;
        const url = addAuthKey(`${apiUrl}/?r=api/candidate-refusal/update&id=${reasonId}`, token);

        const requestData = {
            name: reasonData.name,
            type: reasonData.isCandidateRejected ? "20" : "10",
        };

        const { data } = await axios.put(url, requestData);

        if (data.success) {
            commit("updateReason", data.model);
        }

        return data;
    },
    async deleteReason({ rootState, commit }, reasonId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/candidate-refusal/delete&id=${reasonId}`, token);

        const { data } = await axios.delete(url);

        if (data.success) {
            commit("deleteReason", reasonId);
        }
    },
    async moveReasonToArchive({ rootState, commit }, reasonId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/candidate-refusal/archive&id=${reasonId}`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveReasonToArchive", reasonId);
        }
        return data.success;
    },
    async moveReasonFromArchive({ rootState, commit }, reasonId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/candidate-refusal/unarchive&id=${reasonId}`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveReasonFromArchive", reasonId);
        }

        return data.success;
    },
    async updateSort({ rootState, state }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/candidate-refusal/update-sort`, token);

        const sortingData = state.reasons.map((s, sIndex) => ({ id: s.id, sort: state.reasons.length - sIndex }));

        await axios.patch(url, sortingData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
